import * as React from 'react'

/**
 * The value once it has stopped changing for `ms`: what to ask the API about
 * while someone is still typing, so a word typed is one request, not one per
 * letter.
 */
export function useDebouncedValue<T>(value: T, ms: number): T {
  const [settled, setSettled] = React.useState(value)
  React.useEffect(() => {
    const timer = setTimeout(() => setSettled(value), ms)
    return () => clearTimeout(timer)
  }, [value, ms])
  return settled
}
